import { ArrowRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import apiClient, { IMAGE_BASE_URL } from '../../utils/api-client';
import './Slider.css';

const Slider = () => {
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoplay, setIsAutoplay] = useState(true);

  useEffect(() => {
    if (!isAutoplay || slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoplay, slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };
  useEffect(() => {
    apiClient
      .get('/banner')
      .then((res) => {
        setSlides(res.data.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="slider-wrapper">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={slide.bs_id}
            className={`slider-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img
              src={`${IMAGE_BASE_URL}/${slide.bs_img}`}
              alt={slide.bs_title}
              className="slider-bg-img"
            />
            <div className="slide-overlay" />
            <div className="slider-card">
              <div className="slider-card-body">
                <h2 className="slider-card-title">{slide.bs_title}</h2>
                <p className="slider-card-text">{slide.bs_subtitle}</p>
                <NavLink
                  to={'/shop'}
                  className="slider-btn"
                  onMouseEnter={() => setIsAutoplay(false)}
                  onMouseLeave={() => setIsAutoplay(true)}
                >
                  Shop Now
                  <ArrowRight className="btn-arrow" size={20} />
                </NavLink>
              </div>
            </div>
          </div>
        ))}

        <div className="slider-controls">
          <button
            className="slider-nav-btn"
            onClick={prevSlide}
            onMouseEnter={() => setIsAutoplay(false)}
            onMouseLeave={() => setIsAutoplay(true)}
          >
            <ArrowRight size={20} style={{ transform: 'rotate(180deg)' }} />
          </button>

          <div className="slider-dots">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${
                  index === currentSlide ? 'active' : ''
                }`}
                onClick={() => goToSlide(index)}
                onMouseEnter={() => setIsAutoplay(false)}
                onMouseLeave={() => setIsAutoplay(true)}
              />
            ))}
          </div>

          <button
            className="slider-nav-btn"
            onClick={nextSlide}
            onMouseEnter={() => setIsAutoplay(false)}
            onMouseLeave={() => setIsAutoplay(true)}
          >
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slider;
